import { useTranslation } from 'react-i18next';

export function useFolioManagment() {
  const { t } = useTranslation();

  return { t };
}
